import K from './constants';
import restHelpers from '../helpers/restHelper';

const get = user_id => {
  const users_url = K.API_URL + `/api/v1/users/${user_id}`;
  return restHelpers.withBearer.get(users_url, {});
};

const getAll = () => {
  const users_url = K.API_URL + '/api/v1/users';
  return restHelpers.withBearer.get(users_url, {});
};

const getInstallerProviders = () => {
  const installerProviders_url = K.API_URL + '/api/v1/users/dealers/installers-list';
  return restHelpers.withBearer.get(installerProviders_url, {});
}

const getInstallerProviderAssets = (installerProvider_id) => {
  const installerProviderAssets_url = K.API_URL + `/api/v1/users/installers-available-assets/${installerProvider_id}`;
  return restHelpers.withBearer.get(installerProviderAssets_url, {});
}

const downloadContract = user_id => {
  const users_url = K.API_URL + `/api/v1/users/${user_id}/download`;
  return restHelpers.withBearer.get(users_url, {});
};

const post = data => {
  const users_url = K.API_URL + '/api/v1/users';
  return restHelpers.withBearer.post(users_url, { data });
};

const update = (user_id, data) => {
  const users_url = K.API_URL + `/api/v1/users/${user_id}`;
  return restHelpers.withBearer.put(users_url, { data });
};

const updateAsset = (user_id, asset_id, data) => {
  const users_url = K.API_URL + `/api/v1/users/${user_id}/assets/${asset_id}`;
  return restHelpers.withBearer.put(users_url, { data });
};

const getAssetDetailed = (user_id, asset_id) => {
  const users_url = K.API_URL + `/api/v1/users/${user_id}/assets/${asset_id}?details=true`;
  return restHelpers.withBearer.get(users_url, {});
};

const heartbeat = user_id => {
  const hbeat_url = K.API_URL + `/api/v1/heartbeat?userId=${user_id}`;
  return restHelpers.withBearer.get(hbeat_url, {});
};

const checkGhostDevice = (userId, imei) => {
  const url = K.API_URL + `/api/v2/heartbeat/ghost-device-check?userId=${userId}&imei=${imei}`;
  return restHelpers.withBearer.get(url, {});
};

const activateZuora = user_id => {
  const url = K.API_URL + `/api/v1/zuora/users/activate?asset=default&userId=${user_id}`;
  return restHelpers.withBearer.post(url, {});
};

const createAgreementDigital = (user_id, imei, conditionDocumentName) => {
  const url = K.API_URL + `/api/v1/agreements/create/digital-signature/${user_id}?new&imei=${imei}&conditionDocumentName=${conditionDocumentName}`;
  return restHelpers.withBearer.get(url, {});
};

const createAgreement = (user_id, imei) => {
  const url = K.API_URL + `/api/v1/agreements/create/${user_id}?new&imei=${imei}`;
  return restHelpers.withBearer.get(url, {});
};

const createAgreementForAgricar = (user_id, imei) => {
  const url = K.API_URL + `/api/v1/agreements/create/${user_id}?imei=${imei}&agricar`;
  return restHelpers.withBearer.get(url, {});
};

const sendValidation = (user_id, imei) => {
  const url = K.API_URL + `/api/v1/users/validate/${user_id}?imei=${imei}`;
  return restHelpers.withBearer.get(url, {});
};

const sendContracts = (user_id, imei) => {
  const url = K.API_URL + `/api/v1/users/send-contracts-to-user/${user_id}?imei=${imei}`;
  return restHelpers.withBearer.get(url, {});
};

const resetSignatureMethod = (user_id) => {
  const url = K.API_URL + `/api/v2/profile/reset-signature-method/${user_id}`;
  return restHelpers.withBearer.put(url, {});
};

const del = user_id => {
  const url = K.API_URL + `/api/v1/users/${user_id}`;
  return restHelpers.withBearer.delete(url, {});
};

export default {
 getAll,
  get,
  getInstallerProviders,
  getInstallerProviderAssets,
  post,
  downloadContract,
  update,
  updateAsset,
  getAssetDetailed,
  heartbeat,
  activateZuora,
  createAgreementDigital,
  createAgreement,
  createAgreementForAgricar,
  sendValidation,
  sendContracts,
  resetSignatureMethod,
  delete: del,
  checkGhostDevice
};



// WEBPACK FOOTER //
// ./src/services/users.js